import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { SearchEmployeeDialogService } from 'src/app/services/Non-Master/SearchEmployeeDialog.service';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { tEmployeeModel, tEmployeeWithTypeModel } from 'src/app/models/tEmployeeModel';
import { tEmployeeService } from 'src/app/services/tEmployee.service';
import { isNullOrUndefined } from 'util';
import { DateTimeConvertService } from 'src/app/services/CommonService/DateTimeConvert.service';

@Component({
  selector: 'app-search-employee-dialog',
  templateUrl: './search-employee-dialog.component.html',
  styleUrls: ['./search-employee-dialog.component.css']
})
export class SearchEmployeeDialogComponent implements OnInit {

  TAG = "SearchEmployeeDialogComponent";

  editForm: FormGroup;

  @Input() actionCase: number;
  @Input() onlyTherapist: boolean;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  dataSource: MatTableDataSource<tEmployeeWithTypeModel>;
  checkLoadingDataSource: any;
  dataList: tEmployeeWithTypeModel[];



  displayedColumns: string[] = [
    'employeeID',
    'etypeID',
    'employeeChiName',
    'employeeLeaveStart',
    'employeeLeaveEnd',

  ];


  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private router: Router,
    private formBuilder: FormBuilder,
    private tEmployeeService: tEmployeeService,
    private dateTimeConvertService: DateTimeConvertService,

  ) { }

  //search
  employeeTypeFilter = new FormControl();
  chiNameFilter = new FormControl();
  employeePhoneFilter = new FormControl();

  filteredValues = {
    etypeDesc: '', etypeDescEng: '', employeeChiName: '', employeePhone: ''
  };


  //loading spinner
  isLoading = true;


  ngOnInit() {

    if (isNullOrUndefined(this.actionCase)) {
      this.actionCase = 0;
    }

    if (this.onlyTherapist) {
      //only get therapist (Physio)
      this.getEmployeesOnlyTherapist();
    } else if (this.actionCase === -1) {
      this.getAllData_diagonsis();
    } else {
      this.getAllData();
    }


  }

  getEmployeesOnlyTherapist(){
    console.log('getEmployeesOnlyTherapist');
    this.tEmployeeService.getAllDataOnlyTherapist().subscribe(data => {

      this.dataList = data;

      this.dataSource = new MatTableDataSource<tEmployeeWithTypeModel>(this.dataList);
      this.dataSource.paginator = this.paginator;

      //loading spinner
      this.isLoading = false;
      this.checkLoadingDataSource = data;
      //table sort
      this.dataSource.sort = this.sort;


      //search
      this.employeeTypeFilter.valueChanges.subscribe((employeeTypeFilterValue) => {
        this.filteredValues['etypeDesc'] = employeeTypeFilterValue;
        this.filteredValues['etypeDescEng'] = employeeTypeFilterValue;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });

      this.chiNameFilter.valueChanges.subscribe((chiNameFilterValue) => {
        this.filteredValues['employeeChiName'] = chiNameFilterValue;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });

      this.employeePhoneFilter.valueChanges.subscribe((phoneFilterValue) => {
        this.filteredValues['employeePhone'] = phoneFilterValue;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });
      this.dataSource.filterPredicate = this.customFilterPredicate();


      // this.log.i(this.TAG, "filterPredicate = " + this.customFilterPredicate());
    },
      error => this.isLoading = false);
  }

  getAllData_diagonsis(): void {
    this.log.i(this.TAG, 'getAllData = ');

    this.tEmployeeService.getAllDataWithEmployeeType_diagonsis().subscribe(data => {

      this.dataList = data;

      this.dataSource = new MatTableDataSource<tEmployeeWithTypeModel>(this.dataList);
      this.dataSource.paginator = this.paginator;

      //loading spinner
      this.isLoading = false;
      this.checkLoadingDataSource = data;
      //table sort
      this.dataSource.sort = this.sort;


      //search
      this.employeeTypeFilter.valueChanges.subscribe((employeeTypeFilterValue) => {
        this.filteredValues['etypeDesc'] = employeeTypeFilterValue;
        this.filteredValues['etypeDescEng'] = employeeTypeFilterValue;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });

      this.chiNameFilter.valueChanges.subscribe((chiNameFilterValue) => {
        this.filteredValues['employeeChiName'] = chiNameFilterValue;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });

      this.employeePhoneFilter.valueChanges.subscribe((phoneFilterValue) => {
        this.filteredValues['employeePhone'] = phoneFilterValue;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });
      this.dataSource.filterPredicate = this.customFilterPredicate();


      // this.log.i(this.TAG, "filterPredicate = " + this.customFilterPredicate());
    },
      error => this.isLoading = false);
  }




  getAllData(): void {
    this.log.i(this.TAG, 'getAllData = ');

    this.tEmployeeService.getAllDataWithEmployeeType().subscribe(data => {

      this.dataList = data;

      this.dataSource = new MatTableDataSource<tEmployeeWithTypeModel>(this.dataList);
      this.dataSource.paginator = this.paginator;

      //loading spinner
      this.isLoading = false;
      this.checkLoadingDataSource = data;
      //table sort
      this.dataSource.sort = this.sort;


      //search
      this.employeeTypeFilter.valueChanges.subscribe((employeeTypeFilterValue) => {
        this.filteredValues['etypeDesc'] = employeeTypeFilterValue;
        this.filteredValues['etypeDescEng'] = employeeTypeFilterValue;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });

      this.chiNameFilter.valueChanges.subscribe((chiNameFilterValue) => {
        this.filteredValues['employeeChiName'] = chiNameFilterValue;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });

      this.employeePhoneFilter.valueChanges.subscribe((phoneFilterValue) => {
        this.filteredValues['employeePhone'] = phoneFilterValue;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });
      this.dataSource.filterPredicate = this.customFilterPredicate();


      // this.log.i(this.TAG, "filterPredicate = " + this.customFilterPredicate());
    },
      error => this.isLoading = false);
  }

  customFilterPredicate() {
    const myFilterPredicate = (data: tEmployeeWithTypeModel, filter: string): boolean => {

      let searchString = JSON.parse(filter);
      // number solution: check searchString, if null show all, else skip it
      return (data.etypeDesc.toString().trim().toLowerCase().indexOf(searchString.etypeDesc.toLowerCase()) !== -1
      ||
      data.etypeDescEng.toString().trim().toLowerCase().indexOf(searchString.etypeDescEng.toLowerCase()) !== -1
      )
      &&
      data.employeeChiName.toString().trim().toLowerCase().indexOf(searchString.employeeChiName.toLowerCase()) !== -1
      &&
      (searchString.employeePhone.toLowerCase() == '' ||
      (data.employeePhone != null && data.employeePhone.toString().trim().toLowerCase().indexOf(searchString.employeePhone.toLowerCase()) !== -1))
      ;


    }

    return myFilterPredicate;
  }

  selectedRecord(selectedModel: tEmployeeModel) {
    this.log.i(this.TAG, "selectedRecord data = " + selectedModel.employeeChiName);


    this.activeModal.close(selectedModel);

  }


  formatDate(date: string) {
    if(date!=null && date != ""){
      const newDate = new Date(date);
      return this.dateTimeConvertService.ConvertCurrentDBDay(newDate);

    }


  }


}
